import React from "react";
import { IoCheckmark } from "react-icons/io5";

const ProcessingTask = ({ task, additionalInfo }) => {
  const isZipProcessing =
    task.name === "Criando ZIP" && task.status === "in-progress";

  const getStatusIndicator = () => {
    if (task.status === "completed") {
      return <IoCheckmark style={{ color: "rgba(0, 200, 100)" }} />;
    }

    if (task.status === "in-progress") {
      return (
        <div
          className="spinner"
          style={{
            width: "1.2em",
            height: "1.2em",
            border: "2px solid rgba(0, 150, 255, 0.3)",
            borderTop: "2px solid rgba(0, 150, 255, 0.8)",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
      );
    }

    return task.icon;
  };

  const getZipProgress = () => {
    if (!additionalInfo || !isZipProcessing) return null;

    const { arquivosAdicionadosNoZIP, totalArquivosNoZIP } = additionalInfo;
    if (!arquivosAdicionadosNoZIP || !totalArquivosNoZIP) return null;

    return `${arquivosAdicionadosNoZIP.toLocaleString()} de ${totalArquivosNoZIP.toLocaleString()}`;
  };

  const getStatusText = () => {
    if (task.status === "completed") return "Concluído";

    if (isZipProcessing) {
      const zipProgress = getZipProgress();
      if (zipProgress) {
        return `Arquivos: ${zipProgress}`;
      }
      return "Compactando arquivos...";
    }

    if (task.status === "in-progress") return "Processando...";

    return "";
  };

  return (
    <div className="file">
      <div className="thumb">{getStatusIndicator()}</div>
      <div className="content">
        <div className="text">
          <p>{task.name}</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <p>{task.progress}%</p>
            <span
              style={{
                fontSize: "0.7em",
                color:
                  task.status === "completed"
                    ? "rgba(0, 200, 100)"
                    : "rgba(0, 150, 255)",
                opacity: 0.9,
                animation:
                  task.status === "in-progress" ? "pulse 2s infinite" : "none",
              }}
            >
              {getStatusText()}
            </span>
          </div>
        </div>
        <div className="load">
          <div
            className="progress"
            style={{
              width: `${task.progress}%`,
              backgroundColor:
                task.status === "completed"
                  ? "rgba(0, 200, 100)"
                  : isZipProcessing && task.progress === 100
                  ? "rgba(0, 150, 255, 0.6)"
                  : "rgba(0, 150, 255)",
              transition: "width 0.3s ease-out",
            }}
          />
          {isZipProcessing && task.progress === 100 && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
                animation: "slide 2s infinite linear",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const ProcessingStateDisplay = ({ tasks }) => {
  const zipTask = tasks.find((task) => task.name === "Criando ZIP");
  const isZipProcessing =
    zipTask?.status === "in-progress" && zipTask?.progress === 100;

  return (
    <div className="files">
      {tasks.map((task) => (
        <ProcessingTask
          key={task.id}
          task={task}
          additionalInfo={task.additionalInfo}
        />
      ))}

      {isZipProcessing && (
        <div
          style={{
            padding: "12px",
            margin: "12px",
            backgroundColor: "rgba(0, 150, 255, 0.1)",
            borderRadius: "4px",
            border: "1px solid rgba(0, 150, 255, 0.2)",
          }}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "0.75em",
              color: "rgba(0, 150, 255, 0.8)",
              animation: "pulse 2s infinite",
            }}
          >
            Adicionando arquivos ao ZIP, este processo pode demorar alguns
            minutos...
          </p>
        </div>
      )}

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes pulse {
            0%, 100% { opacity: 0.6; }
            50% { opacity: 1; }
          }
          @keyframes slide {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
        `}
      </style>
    </div>
  );
};

export default ProcessingStateDisplay;
